<h2 class="mat-h2">Treatment goals</h2>
<div echarts [options]="options"></div>
